import axios from 'axios';
import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Button from 'react-bootstrap-button-loader';

// used for add and edit
const AddProvinceModal = ({ addProvinceModal, setAddProvinceModal, getAll, selectedCountry, selectedProvince, setSelectedProvince, clearStates, modalType, queueBranches }) => {

  const [baseUrl, setBaseUrl] = useState('');
  const [token, setToken] = useState('');
  const [userDetails, setUserDetails] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedQueueBranch, setSelectedQueueBranch] = useState(null);

  const [provinceName, setProvinceName] = useState('');

  // if modal type is edit, set value
  useEffect(() => {
    if (modalType === 1) {
      setProvinceName(selectedProvince.name)
    }
  }, [selectedProvince]);

  // get base url & token
  useEffect(() => {
    setBaseUrl(localStorage.getItem('API_URL'));
    setToken(localStorage.getItem('user_token'));
    setUserDetails(JSON.parse(localStorage.getItem('user_details')));
  }, [AddProvinceModal])

  // addNewProvince - function
  const addNewProvince = () => {
    console.log('addNewProvince function start');
    setButtonLoader(true);

    // validate
    if (provinceName.length > 0) {

      axios({
        url: `${baseUrl}/branch/add/primary/parent/${selectedCountry.id}`,
        method: 'POST',
        headers: {
          Authorization: token
        },
        data: {
          name: provinceName,
          level: 2
        }
      }).then((res) => {

        console.log('>> addNewProvince success');
        setSelectedProvince(res.data.data);
        clearStates(2);

        setButtonLoader(false);
        closeModal();
        toast.remove();
        toast.success('Successfully added', {
          position: 'bottom-center',
        });

        getAll(1, 0);
        getAll(2, selectedCountry.id);

      }).catch((error) => {
        console.log('>> addNewProvince error');
        console.log(error);
        setButtonLoader(false);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: 'bottom-center',
          });
        } else {
          toast.remove();
          toast.error('Something went wrong', {
            position: 'bottom-center',
          });
        }
      })

    } else {
      setButtonLoader(false);
      toast.remove();
      toast.error('Province name can not be empty', {
        position: 'bottom-center',
      });
    }
  }

  // editProvince - function
  const editProvince = () => {
    console.log('editProvince function working');
    setButtonLoader(true);

    // validate
    if (provinceName.length > 0) {

      if (provinceName === selectedProvince.name) {
        setButtonLoader(false);
        toast.remove();
        toast.error('Same province name. No need to update', {
          position: 'bottom-center',
        });

      } else {

        axios({
          url: `${baseUrl}/branch/update/region`,
          method: 'POST',
          headers: {
            Authorization: token
          },
          data: {
            id: selectedProvince.id,
            name: provinceName,
            customer: {
              id: userDetails.cid
            }
          }
        }).then((res) => {

          console.log('>> editProvince success');
          closeModal();
          setButtonLoader(false);
          toast.remove();
          toast.success('Successfully updated', {
            position: 'bottom-center',
          });

          getAll(2, selectedCountry.id);

        }).catch((error) => {
          console.log('>> editProvince error');
          console.log(error);
          setButtonLoader(false);

          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: 'bottom-center',
            });
          } else {
            toast.remove();
            toast.error('Something went wrong', {
              position: 'bottom-center',
            });
          }
        })

      }

    } else {
      setButtonLoader(false);
      toast.remove();
      toast.error('Province name can not be empty', {
        position: 'bottom-center',
      });
    }

  }

  const mapQueueProvince = () => {
    console.log("queue branch: ", queueBranches)
    console.log("selected queue branch: ", selectedQueueBranch)

    console.log("selected province: ", selectedProvince)

    if (selectedQueueBranch === null) {
      setButtonLoader(false);
      toast.remove();
      toast.error('Not selected queue branch', {
        position: 'bottom-center',
      });

      // } else if (selectedQueueBranch === selectedCountry.name) {
      //     setButtonLoader(false);
      //     toast.remove();
      //     toast.error('Same country name. No need to update', {
      //         position: 'bottom-center',
      //     });

    } else {
      axios({
        url: `${baseUrl}/branch/map-queue-branch`,
        method: 'POST',
        headers: {
          Authorization: token
        },
        data: {
          branchId: selectedProvince.id,
          queueBranchId: selectedQueueBranch.id,
          queueBranchName: selectedQueueBranch.name
        }
      }).then((res) => {

        getAll(2, selectedCountry.id);
        setButtonLoader(false);
        closeModal();
        toast.remove();
        toast.success(res.data.data, {
          position: 'bottom-center',
        });

        // getAll(1, 0);

      }).catch((error) => {
        console.log('>> editCountry error');
        console.log(error);
        setButtonLoader(false);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: 'bottom-center',
          });
        } else {
          toast.remove();
          toast.error('Something went wrong', {
            position: 'bottom-center',
          });
        }
      })
    }
  }

  // closeModal - function
  function closeModal() {
    setAddProvinceModal(false);
  }

  // when click esc, close modal
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setAddProvinceModal(false);
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  return (
    <>
      <Toaster />
      {addProvinceModal ?
        <div className={`modal fade  d-block show modal-container`} id="exampleModal">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">

                {modalType === 0 ? (
                  <h5 className="modal-title" id="exampleModalLabel"> Add New Province</h5>
                ) : (
                  <h5 className="modal-title" id="exampleModalLabel"> Edit Province</h5>
                )}

                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                  onClick={() => {
                    closeModal()
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">

                <div className="input-group input-group-sm mb-3 modal-input-group">
                  <p className='input-field-side-text'>Province Name : </p>

                  {modalType === 0 ? (
                    // add text field
                    <input autoFocus type="text" className="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                      onChange={(e) => {
                        setProvinceName(e.target.value);
                      }}
                    />
                  ) : modalType === 1 ? (
                    // edit text field
                    <input autoFocus type="text" className="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                      value={provinceName}
                      onChange={(e) => {
                        setProvinceName(e.target.value);
                      }}
                    />
                  ) : (
                      <>
                        {queueBranches !== null ? (
                            <select
                                className="custom-select modal-select-field mr-2 select-branch-dropdown"
                                id="inputGroupSelect01"
                                // value={branchDropDValue}
                                onChange={(e) => {
                                  setSelectedQueueBranch(queueBranches[e.target.value]);
                                  // handleSelectBranch(allBranchesList[e.target.value]);
                                }}
                            >
                              <option defaultValue hidden>
                                Select Branch...
                              </option>
                              {queueBranches.map((item, index) => (
                                  <option value={index} key={index}>
                                    {item.name}
                                  </option>
                              ))}
                            </select>
                        ) : null}
                      </>
                  )}

                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal"
                  onClick={() => {
                    closeModal()
                  }}>Cancel</button>

                {modalType === 0 ? (
                  <Button loading={buttonLoader} type="button" className="btn btn-primary"
                    onClick={() => {
                      addNewProvince();
                    }}
                  >Add Province</Button>
                ) : modalType === 1 ? (
                  <Button loading={buttonLoader} type="button" className="btn btn-primary"
                    onClick={() => {
                      editProvince();
                    }}
                  >Edit Province</Button>
                ) : (
                    <Button loading={buttonLoader} type="button" className="btn btn-primary"
                            onClick={() => {
                              mapQueueProvince();
                            }}
                    >Map Province</Button>
                )}

              </div>
            </div>
          </div>
        </div>

        : ''}
    </>
  )
}

export default AddProvinceModal;